export default {
    getHeaderFieldsEprofileVedooltasok: state => state.headerFieldsEprofileVedooltasok,
    getFormActionsEprofileVedooltasok: state => state.formActionsEprofileVedooltasok,
    getActionsEprofileVedooltasok: state => state.actionsEprofileVedooltasok,
    getRowActionsEprofileVedooltasok: state => state.rowActionsEprofileVedooltasok,
    getSearchFields: state => state.searchFields,
    isFormOpenEprofileVedooltasok: state => state.formIsOpen,
    isGridOpenEprofileVedooltasok: state => state.gridIsOpen
}
